export const ru = {
    new_travel_policy: 'Новая тревел-политика',
};
